import type { FaireProductEntity } from "../../entity_types/product";

export const p_ksyet3w8th: FaireProductEntity = {
  token: "p_ksyet3w8th",
  type: "product",
  name: "fruit paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/2a15b7f7821c557ea1e56ea5b088bad19295351418a149aac114c5afcb838cd9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80234a2286635da4975a8597c8ee1e5f9f2f44801f1d0ad11a9a042534cc83d5.jpeg",
    "https://cdn.faire.com/fastly/65c09bf78804d8d6808920ae25d97b3ece94e8c862bbb85c784c9c17939ae9e7.jpeg",
    "https://cdn.faire.com/fastly/1aa49ec1986b9ec1756c88b111bb3c282a98ba1bd9097f8e98ac719b9a32b57c.jpeg",
    "https://cdn.faire.com/fastly/20021b40ed71d90aeddc3c27a6901048e55c9e5d54c9403cec56583e644f487f.jpeg",
    "https://cdn.faire.com/fastly/5d9faad61a1f435c5766f75ae8827ebb14535edb08006395f6a862c699615cfc.jpeg",
    "https://cdn.faire.com/fastly/ff1c033ab5838391db43b10fdb0297abf48758724e5850d6261f2f2a51b20714.jpeg",
  ],
  priceDollars: 13,
  description:
    "A cheerful evergreen style with strong spring and summer velocity. Customers paint the cards themselves and send them — no experience necessary, simple instructions included.\n\nIllustrations: strawberry, lemon, orange, blueberry.\n\n$9 wholesale · $18 retail · set of eight notecards + envelopes\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:06.452Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
